export { EllipsisText } from './styles'
export { Text } from './text'
